import MuiLoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton'
import React from 'react'

import styled from '../../constants/theme'

export const PillContainer = styled.div({
  textAlign: 'right',
  '.Pill + .Pill': {
    marginLeft: 8,
  },
})

interface Props extends LoadingButtonProps {
  ariaLabel?: string
  isSaving?: boolean
  onClick?: (e: any) => any
  rel?: string
  target?: string
}

const PillButton: React.FC<Props> = (props) => {
  const {
    ariaLabel,
    children,
    className,
    color,
    isSaving,
    onClick,
    rel,
    target,
    title,
    variant,
    type,
    ...rest
  } = props
  const sharedProps = {
    ...rest,
    'aria-label': ariaLabel,
    className: `Pill ${className ? className : ''}`,
    onClick,
    rel,
    target,
    title: title || (typeof children === 'string' ? children : undefined),
  }
  const computedVariant = variant || 'outlined'
  const computedColor =
    color || (computedVariant === 'outlined' ? 'primary' : 'secondary')
  return (
    <MuiLoadingButton
      color={computedColor}
      loading={isSaving}
      type={type ? type : 'button'}
      variant={computedVariant}
      {...sharedProps}
    >
      {typeof isSaving === 'boolean' ? <span>{children}</span> : children}
    </MuiLoadingButton>
  )
}

export default PillButton
